import { render, staticRenderFns } from "./StatisticLevelYear.vue?vue&type=template&id=ba07a71a&scoped=true"
import script from "./StatisticLevelYear.vue?vue&type=script&lang=js"
export * from "./StatisticLevelYear.vue?vue&type=script&lang=js"
import style0 from "./StatisticLevelYear.vue?vue&type=style&index=0&id=ba07a71a&prod&scoped=true&lang=scss"
import style1 from "./StatisticLevelYear.vue?vue&type=style&index=1&id=ba07a71a&prod&scoped=true&lang=css"
import style2 from "./StatisticLevelYear.vue?vue&type=style&index=2&id=ba07a71a&prod&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ba07a71a",
  null
  
)

export default component.exports